{
  "splash": {
    "title": "Developed with the support of the Government of Canada"
  },
  "all-listings": {
    "disconnected": {
      "text": "Create an account or log in to see the available resources on ACCÈS REFRAIN."
    },
    "needLogin": {
      "secondLine": "Create an account or log in to see the available resources on ACCÈS REFRAIN."
    },
    "empty": {
      "offer": {
        "firstLine": "Start your adventure here!",
        "primaryButtonText": "Publish an offer!",
        "secondLine": "Contribute to the catalog by offering objects to lend."
      },
      "invite": {
        "primaryButtonText": "Invite other members",
        "secondLine": "Invite other members or publish an offer in your club."
      }
    },
    "banner": {
      "xmas": {
        "text": "The holidays are approaching! Help other members find these frequently requested items."
      }
    },
    "inviteOthersPrompt": {
      "ctaButton": "Invite other members"
    },
    "postOfferPrompt": {
      "firstAfter": {
        "button": "Invite other members",
        "title": "Invite other members!"
      },
      "third": {
        "title": "Ask other members"
      }
    }
  },
  "billboard": {
    "unauthenticatedTitle": "Create an account or log in",
    "unauthenticatedTitle_2": "to see the available resources in ACCÈS REFRAIN."
  },
  "common": {
    "appName": "ACCÈS REFRAIN",
    "appDownloadPrompt": {
      "guest": "Like what you see? Get ACCÈS REFRAIN on your phone and receive new availability near you",
      "qrCodeAccessibilityLabel": "QR code to download the ACCÈS REFRAIN app"
    }
  },
  "contact-information": {
    "prompt": "Add the festival's postal code to see which objects are available nearby.",
    "title": "Your festival"
  },
  "contact-us": {
    "firstParagraph": "ACCÈS REFRAIN member service is accessible by email and messaging. We will respond to you as quickly as possible.",
    "faqLink": "https://lerefrain.com/en/foire-aux-questions-acces-refrain-2",
    "chatPrompt": {
      "bugReport": "Hi! 😊\n\nThank you for explaining what's wrong.",
      "suggestion": "Hi! 😊\n\nWe are always open to feedbacks. Thank you for helping us improve our service.\n\nThank you!"
    }
  },
  "credentials": {
    "activationCodeFieldHelp": "An invitation code is required to use ACCÈS REFRAIN. To get one, go to <a>the Refrain member area</a>.",
    "activationCodeFieldHelpLink": "https://lerefrain.com/en/connexion"
  },
  "guidelines": {
    "fifthParagraph": "Do not use ACCÈS REFRAIN to sell objects.",
    "startingKit": "I want to receive the <startingKitLink>Starting Kit</startingKitLink> by mail to recruit other members (optional)"
  },
  "impact": {
    "levels": {
      "0": {
        "description-completed": "Join ACCÈS REFRAIN",
        "title": "Explorer"
      }
    }
  },
  "introModal": {
    "title": "Dear {{name}},",
    "first": "Welcome to the sharing application and discover the <strong>vast catalog of available material resources!</strong>",
    "second": "<strong>Sharing is a sign of trust</strong>: the more you lend, the more others will want to lend to you!",
    "third": "<strong>Know that less than 0.1% of all shares</strong> result in a break. And it's not in bad faith. It's just normal when objects are used a little more.",
    "notInsurable": {
      "community": "<strong>It’s the perfect opportunity to connect with other members</strong> and take a step toward a more sustainable world."
    },
    "welcome": {
      "withWho": {
        "enterprise": "your colleagues and other members",
        "municipal": "other members",
        "municipal_closed": "other members",
        "realestate": "other members"
      }
    }
  },
  "landing-page": {
    "popularInterests": "Categories",
    "multipleOfferCard": {
      "title": "You probably have these items!"
    },
    "immature": {
      "referral": {
        "button": "Invite other members"
      }
    },
    "requests": {
      "emptyState": {
        "subtitle": "We will notify you if other members need help"
      }
    }
  },
  "my-information": {
    "firstNameFieldLabel": "Festival name",
    "credentialInformationTitle": "Account & security",
    "personalInformationTitle": "Profile information"
  },
  "my-personal-information": {
    "firstNameFieldLabel": "Festival name",
    "firstNameFieldPlaceholder": "ex. Bon-Vent de Ste-Pépitte Festival",
    "title": "Profile information"
  },
  "my-plan": {
    "businessPlan": {
      "firstParagraph": {
        "enterprise": "Your ACCÈS REFRAIN subscription is a courtesy of the Refrain."
      },
      "title": {
        "enterprise": "ACCÈS REFRAIN subscription"
      }
    },
    "refrainPlan": {
      "firstParagraph": "",
      "title": "ACCÈS REFRAIN subscription"
    },
    "noEnd": "This subscription is valid as long as you are a member of Refrain.",
    "design": {
      "freeBorrowDescription": "Borrow your first item from other members for free",
      "unlimitedLendingDescription": "Publish offers and lend your items to other members as often as you like"
    }
  },
  "new": {
    "itemInformationSection": {
      "nameFieldPlaceholder": "ex: Sound console",
      "descriptionFieldPlaceholder": {
        "offer": "Brand, dimensions, color, weight, condition, year of acquisition, borrowing conditions, object specifics ...",
        "request": "Brand, dimensions, color, weight, condition, year of acquisition, borrowing conditions, object specifics ..."
      }
    }
  },
  "notifications": {
    "introModal": {
      "intro": {
        "title": "Welcome to the club",
        "body": "Discover ACCÈS REFRAIN!"
      }
    },
    "welcome": "Welcome to ACCÈS REFRAIN!",
    "welcomeMessage": "Thank you for trusting us.",
    "rate": {
      "borrower": {
        "message": "Your opinion is important to us and to other members of ACCÈS REFRAIN."
      },
      "lender": {
        "message": "Your opinion is important to us and to other members of ACCÈS REFRAIN."
      }
    },
    "loanReciprocity": {
      "message": "Post the items you rarely use and share them with other members."
    }
  },
  "one-channel": {
    "levelModal": {
      "superSharer": {
        "message": "You have increased your impact by making 5 shares! You now access the ultimate level: <strong>Super Sharer</strong> and a role model for other members of ACCÈS REFRAIN.\n\nBravo! With each share, you grow your impact for a greener future."
      }
    },
    "howItWorks": {
      "borrow": {
        "step2": "<bold>Suggest</bold> borrowing dates, <bold>wait for confirmation</bold> from the other member then <bold>plan the pickup</bold> together",
        "step3": "<bold>Pick up the item</bold> from the other member or at a safe public place. <bold>No money exchanged, it's free!</bold>"
      },
      "lend": {
        "step3": "<bold>Lend the item</bold> to the other member. <bold>No money exchanged, it's free!</bold>"
      }
    }
  },
  "one-listing": {
    "needFoundModal": {
      "step2": {
        "gotoSelectLender": "The need has been fulfilled on ACCÈS REFRAIN"
      }
    }
  },
  "personal-information": {
    "firstNameFieldLabel": "Festival name",
    "firstNameFieldPlaceholder": "ex. Bon-Vent de Ste-Pépitte Festival",
    "pictureFieldSubtitle": "This image will be displayed in your ads and your profile.",
    "pictureFieldTitle": "Add an image of the festival logo",
    "title": "Profile information"
  },
  "privacy": {
    "link1": "https://lerefrain.com/en/acces-refrain-terms-of-use",
    "link2": "https://lerefrain.com/en/acces-refrain-politique-de-confidentialite",
    "line3": "of ACCÈS REFRAIN."
  },
  "quick-new-thanks": {
    "bodyText": "You have just helped enrich the <strong>ACCÈS REFRAIN</strong> catalog! \n\nYou can modify your offers at any time in your sharing center."
  },
  "ratings": {
    "notGreat": {
      "ctaButton": "Contact ACCÈS REFRAIN"
    }
  },
  "tutorial": {
    "multipleOffers": {
      "step1": {
        "text": "By offering your objects, you encourage even the most timid festivals to ask."
      }
    },
    "publishOffers": {
      "step2": {
        "text": "By offering your items, you even encourage <strong>the shyest members</strong> to ask. You can always lend your items, even <strong>without a subscription</strong>.\n\nTap the icon to continue. (2/5)"
      },
      "step2AltCorp": {
        "text": "By offering your items, you even encourage <strong>the shyest members</strong> to ask.\n\nTap the icon to continue. (2/5)"
      }
    }
  },
  "festival": {
    "nextEdition": "Next edition",
    "changeLater": "You can change the date later in your profile",
    "startDate": "Start date",
    "chooseDate": "Confirm your date",
    "address": "Address",
    "profileTitle": "Next edition start date",
    "missingDate": "Date to be confirmed",
    "expired": "Expired",
    "edit": "Edit",
    "editTitle": "Change the next edition’s start date",
    "cancel": "Cancel",
    "save": "Save",
    "close": "Close",
    "dateRequired": "Select a start date of today or later.",
    "saveError": "The date could not be saved. Please try again.",
    "initialTitle": "When does the next edition start?",
    "initialMessage": "Enter the start date of your festival’s next edition.",
    "reminderTitle": "Get ready for the next edition!",
    "reminderMessage": "It’s time to update the start date of your festival’s next edition.",
    "updateDate": "Update the date",
    "later": "Later",
    "signupTitle": "Your festival"
  },
  "presentPartageClub": {
    "community": {
      "headerText": "Accès Refrain is the app for <strong>sharing equipment</strong> between festivals.",
      "footerText": "Don't <strong>limit</strong> yourself to what your organization owns."
    },
    "accessMore": {
      "headerText": "With Accès Refrain, you have access to an <strong>abundance of equipment</strong>.",
      "footerText": "Equipment, stages, and more: here, you'll find <strong>absolutely everything.</strong>"
    },
    "offerMore": {
      "headerText": "With Accès Refrain, <strong>sharing</strong> means <strong>helping</strong> other festivals while <strong>making the most of your resources</strong>.",
      "footerText": "Let other festivals <strong>benefit</strong> from your <strong>underused equipment.</strong>"
    }
  },
  "help": {
    "guestCta": {
      "text": "Join other members and discover what you can borrow nearby."
    },
    "borrower": {
      "steps": {
        "catalog": {
          "text": "Search for an item in the catalog or post a need visible to other members"
        },
        "meeting": {
          "text": "Propose and confirm borrowing and pickup dates with the other member"
        },
        "pickup": {
          "text": "Meet the other member at their home or in a safe public place. <strong>No money changes hands — it's free!</strong>"
        }
      }
    },
    "lender": {
      "steps": {
        "share": {
          "text": "Meet the other member at your home or in a safe public place to hand over the item. <strong>No money changes hands — it's free!</strong>"
        }
      }
    }
  },
  "free-sub": {
    "inviteButtonText": "Invite other members",
    "spreadTheLoveText": "Tell other members about it so they can also enjoy the special offer!"
  },
  "invite": {
    "referralProgram": {
      "shareText": "Hey!\n\nI’ve been using ACCÈS REFRAIN, an app to share everyday items. It’s super handy and I’m sure you’ll love it. Join me:\n\n{{url}}"
    },
    "referralProgram202506": {
      "shareText": "Hey!\n\nI’ve been using ACCÈS REFRAIN, an app to share everyday items. It’s super handy and I’m sure you’ll love it. Join me:\n\n{{url}}"
    },
    "shareText": "Hey!\n\nI’ve been using ACCÈS REFRAIN, an app to share everyday items. It’s super handy and I’m sure you’ll love it. Join me:\n\n{{url}}",
    "title": "Invite other members or relatives!"
  },
  "loans": {
    "past": {
      "savings": {
        "header": {
          "lending": "Saved by other members thanks to you"
        }
      }
    }
  },
  "my-impact-financial": {
    "empty": {
      "lending": {
        "secondLine": "Share your items and see how much money you allow other members to save!"
      }
    },
    "emptyByTransaction": {
      "lend": {
        "lending": {
          "secondLine": "Share your items and see how much money you allow other members to save!"
        }
      }
    }
  },
  "my-neighbourhood": {
    "radiusDescription": "Your radius allows you to share your listings within a limited area of your neighbourhood. Members living outside of this zone will not be able to see your listings."
  },
  "payment": {
    "modal": {
      "firstParagraph": "Thanks for trusting us. With your subscription, you can now borrow and lend unlimited items with other members."
    }
  },
  "posts": {
    "feed": {
      "endOfFeed": {
        "description": "A borrowed item, a new connection…\nShare your story with other members."
      }
    },
    "storyComposer": {
      "neighbour": "a member"
    }
  },
  "presentCommunity": {
    "newFlow": {
      "oneFreeBorrowDescription": "Borrow your first item from a member for free",
      "unlimitedLendingDescription": "Post offers and lend your items to members as often as you like"
    }
  },
  "profile-overview": {
    "inviteNeighboursButtonLabel": "Invite members"
  },
  "recommendations": {
    "urgent-needs": {
      "title": "Help other members!"
    }
  },
  "streak": {
    "contributions": {
      "add_avatar": {
        "description": "A profile picture reassures other members and makes you recognisable in the community."
      },
      "dismiss_request": {
        "title": "Try to help other members"
      },
      "publish_offer": {
        "description": "Publish a specific item, or choose from suggested items already shared by our members!"
      },
      "send_message": {
        "description": "Break the ice! Write to a member to offer help or learn more about a listing."
      }
    },
    "neighbourhoodFirstShare": "In your neighbourhood, <strong>{{percent}}% of other members</strong> made their first share <strong>in less than a week</strong>",
    "objectiveDetails": "The objective for the month is determined based on the number of sharing members around you and the maturity of your neighbourhood.",
    "seriesDetails": "To keep the sharing flame alive, you and other members must reach the indicated sharing goal for the month.",
    "tips": {
      "helpNeighbours": {
        "title": "Try to help other members"
      }
    }
  }
}
